/**
 * Verse selection utilities with improved relevance and penalization for overused verses
 */

interface VerseCandidate {
  reference: string;
  text: string;
  score?: number;
}

/**
 * Penalizes Romans 8:28 unless explicitly requested to reduce "canned" feeling
 */
export function penalizeOverusedVerses(verses: VerseCandidate[], requestText: string): VerseCandidate[] {
  const requestMentionsRomans = /Romans\s*8:28/i.test(requestText);
  
  return verses.map(verse => {
    const isRomans828 = /Romans\s*8:28/i.test(verse.reference);
    
    // Penalize Romans 8:28 unless specifically requested
    const penaltyFactor = (isRomans828 && !requestMentionsRomans) ? 0.85 : 1;
    
    return {
      ...verse,
      score: (verse.score ?? 1) * penaltyFactor
    };
  });
}

/**
 * Builds enhanced search query with thematic hints for better verse relevance
 */
export function buildThematicSearchQuery(requestText: string, tags: string[] = []): string {
  const tagHints = tags.join(' ');
  const thematicKeywords = 'patience endurance hope comfort anxiety peace forgiveness mercy grace love joy strength wisdom protection guidance healing salvation redemption faith trust';
  
  return `${requestText} ${tagHints} ${thematicKeywords}`.trim();
}

/**
 * Sorts verse candidates by relevance score
 */
export function sortVersesByRelevance(verses: VerseCandidate[]): VerseCandidate[] {
  return verses.sort((a, b) => {
    const scoreA = a.score ?? 0;
    const scoreB = b.score ?? 0;
    
    // Primary sort: by score (higher is better)
    if (scoreB !== scoreA) {
      return scoreB - scoreA;
    }
    
    // Secondary sort: by text length (shorter is better for prayers)
    return a.text.length - b.text.length;
  });
}